module.exports = __webpack_public_path__ + "img/ic_record_send.a1fa2360.png";